import alt from "../alt";

class WishlistActions {
  constructor() {
    this.generateActions("add", "remove", "fetch", "orderUnticketed");
  }
}

export default alt.createActions(WishlistActions);



// WEBPACK FOOTER //
// ./src/app/actions/WishlistActions.js